import React from "react";

const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="12">
    <path
      fill="transparent"
      stroke="#B90C2F"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M28.143 1.356l4.576 4.619-4.934 4.981M31.355 6H1.161"
    />
  </svg>
);

export default Arrow;
